import api from '../services/api';

// In-memory cache for presigned URLs (valid for 12 min; server issues 15-min URLs)
const presignedUrlCache = new Map();
const CACHE_TTL = 12 * 60 * 1000;

const uploadsApi = {
  uploadFile: (file, destinationPath, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('destinationPath', destinationPath);

    return api.post('/uploads', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
  },

  getSecureUrl: async (path) => {
    // Return cached URL if still valid
    const cached = presignedUrlCache.get(path);
    if (cached && Date.now() < cached.expiresAt) {
      return cached.url;
    }

    try {
      const response = await api.post('/uploads/get-secure-url', { path });
      const url = response.data.url;
      presignedUrlCache.set(path, { url, expiresAt: Date.now() + CACHE_TTL });
      return url;
    } catch (error) {
      console.error('Error fetching secure URL:', error);
      throw error;
    }
  },

  clearCache: () => {
    presignedUrlCache.clear();
  },
};

export default uploadsApi;
